export const DEFAULT_FLOATING_SIDE = "bottom" as const;
export const DEFAULT_FLOATING_ALIGN = "center" as const;
export const DEFAULT_FLOATING_SIDE_OFFSET = 4;
export const DEFAULT_FLOATING_ALIGN_OFFSET = 0;

export const resolveFloatingPlacement = (
  side?: "top" | "right" | "bottom" | "left",
  align?: "start" | "center" | "end",
) => {
  const resolvedSide = side ?? DEFAULT_FLOATING_SIDE;
  const resolvedAlign = align ?? DEFAULT_FLOATING_ALIGN;

  if (resolvedAlign === DEFAULT_FLOATING_ALIGN) {
    return resolvedSide;
  }

  return `${resolvedSide}-${resolvedAlign}` as const;
};
